<template>
  <div class='EnbNaveMobi'
  :style="{ 
    backgroundColor: Prefes.nave.corBackground,
    fontFamily: Prefes.nave.font,
    color: Prefes.nave.corFont,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
  }"
  >
    <div class="link-nave"><label @click="ToggleSideNave(true)">|||</label></div>
    <enb-logo01/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EnbLogo01 from '@/components/Naves/EnbNave01/EnbLogo01'
export default {
  name: 'EnbNaveMobi',
  components: { EnbLogo01 },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['ToggleSideNave'])
  }
}
</script>

<style scoped>
.EnbNaveMobi {
  width: 100%;
  height: 20%;
  align-items: center;
}

.link-nave {
  width: 10%;
}

label {
  display: block;
  transform: rotate(90deg);
}

@media screen and (min-width: 500px) {
  .EnbNaveMobi {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .EnbNaveMobi {
    display: flex;
  }
}
</style>
